// TODO: rename module
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import stSelectComponent from './stSelect.component';

const stSelectModule = angular.module('stSelect', [
    uiRouter
  ])
  .component('stSelect', stSelectComponent)
  .name;

export default stSelectModule;



// WEBPACK FOOTER //
// ./client/app/common/stSelect/stSelect.js